/// <reference path="components/appcomponent.ts" />

import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core'; // enableProdMode,


import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';

import { PopupComponent } from './components/Popup/PopupComponent';
import { ErrorComponent } from './components/Error/ErrorComponent';
import { GuestsComponent } from './components/Guests/GuestsComponent';
import { Guests } from './components/Guests/Guests';
import { EditGuestDialog } from './components/Guests/saveGuest/editGuest.dialog';
import { Subscriptions } from './components/Guests/Subscriptions';
import { EditSubscriberDialog } from './components/Guests/saveSubscriber/editSubscriber.dialog';
import { LoginComponent } from './components/Login/LoginComponent';

import { CanActivateViaAuthGuard } from './router/AuthGuard';
import { routing } from './router/router';

import { FormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { AuthService } from './services/AuthService';
import { AuthServiceGuest } from './services/AuthServiceGuest';
import { LanguageService } from './services/LanguageService';
import { GuestsService } from './services/GuestsService';

// Pipes
import { FilterByTitleAndTextPipe } from './common/pipes/filterByTitleAndText';
import { MultiArgSearch } from './common/modules/multiArgSearch';
import { SortByParam } from './common/pipes/sortByParam';
import { FormatDate } from './common/pipes/formatDate';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './components/appcomponent';
import { NavMenuComponent } from './components/Guests/nav-menu/nav-menu.component';
import { DatePipe } from '@angular/common';
import { ConfigService } from './shared/services/config.service';
import { Parks } from './components/Guests/Parks';
import { destinedParkTranslatePipe } from './common/pipes/destinedParkTranslate';
import { ImportGuestsDialog } from './components/Guests/importGuests/importGuests.dialog';
import { SideMenuComponent } from './components/Guests/sideMenu/sideMenu';
import { UsersComponent } from './components/users/users.component';
import { editPermissionTranslatePipe } from './common/pipes/editPermissionsTranslate';
import { visibilityPermissionsTranslatePipe } from './common/pipes/visibilityPermissionsTranslate';
import { EditUserDialog } from './components/users/editUser/editUser.dialog';
import { NavMobilePanelComponent } from './components/Guests/nav-mobile-panel/nav-mobile-panel.component';

import {
  DateAdapter,
  //MatNativeDateModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

//import { GlobalErrorHandler } from './errors/global-error-handler';

export const DateFormats = {

  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    HttpClientModule,
    MultiArgSearch,
    routing,
    FormsModule,
    NgxMaterialTimepickerModule,
    //NgxMaterialTimepickerModule.setLocale('he'),
    NgxMaterialTimepickerModule.setOpts('he-IL', 'arab'),
    SharedModule],
  // declare applications components
  declarations: [
    AppComponent,

    FilterByTitleAndTextPipe,
    SortByParam,
    FormatDate,
    PopupComponent,
    ErrorComponent,
    GuestsComponent,
    Guests,
    Subscriptions,
    Parks,
    LoginComponent,
    UsersComponent,

    EditGuestDialog,
    EditSubscriberDialog,
    EditUserDialog,
    NavMenuComponent,
    ImportGuestsDialog,
    SideMenuComponent,
    NavMobilePanelComponent,

    destinedParkTranslatePipe,
    editPermissionTranslatePipe,
    visibilityPermissionsTranslatePipe

  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [ConfigService],
      useFactory: (appConfigService: ConfigService) => {
        return () => {
          return appConfigService.loadAppConfig();
        };
      }
    },
    { provide: MAT_DATE_LOCALE, useValue: 'he-IL' }, // Alex for date picker format
    { provide: MAT_DATE_FORMATS, useValue: DateFormats },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    ConfigService,
    DatePipe,
    editPermissionTranslatePipe,
    visibilityPermissionsTranslatePipe,
    LanguageService,
    GuestsService,
    CanActivateViaAuthGuard,
    AuthService,
    AuthServiceGuest
  ],

  entryComponents: [EditGuestDialog, EditSubscriberDialog, ImportGuestsDialog, EditUserDialog],
  bootstrap: [AppComponent]
})

export class AppModule { }
